<template>
  <b-modal
    v-model="showModal"
    ok-title="Save"
    cancel-title="Cancel"
    ok-variant="rounded"
    cancel-variant="link"
    @ok="save"
    @hidden="hide"
  >
    <b-form-checkbox-group
      v-for="zone in cachedAvailableZones"
      :key="zone.id"
      v-model="selected"
      :value-field="zone.code"
      :text-field="zone.name"
    >
      <b-form-checkbox :value="zone.code" @change="change => onChange(!!change, zone)">
        <template v-if="zone.name"> {{ zone.name }} ({{ zone.code }}) </template>
        <template v-else>
          {{ zone.code }}
        </template>
      </b-form-checkbox>
    </b-form-checkbox-group>
  </b-modal>
</template>

<script>
import findIndex from 'lodash/findIndex';

export default {
  name: 'LicenceAreaZonesList',
  props: ['show', 'zones', 'availableZones', 'licenceAreaCode'],
  data() {
    return {
      selected: [],
      showModal: this.show
    };
  },
  computed: {
    cachedAvailableZones() {
      return Object.assign([], this.availableZones);
    },
    cachedSelectedZones() {
      return Object.assign([], this.zones);
    }
  },
  watch: {
    show(showModal) {
      this.showModal = showModal;
    },
    zones() {
      this.setSelectedZones();
    }
  },
  mounted() {
    this.setSelectedZones();
  },
  methods: {
    getSelectedZones() {
      return this.cachedSelectedZones.map(zone => zone.code);
    },
    setSelectedZones() {
      this.selected = this.getSelectedZones();
    },
    hide() {
      this.$emit('hide');
    },
    save() {
      this.$emit('save', this.licenceAreaCode, this.selected);
    },
    onChange(isChecked, zone) {
      const zoneIndex = findIndex(this.cachedAvailableZones, { code: zone.code });
      this.$set(this.cachedAvailableZones, zoneIndex, { ...zone, selected: isChecked });
    }
  }
};
</script>
